import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { apiFetchOrg } from 'api/apiOrg';
import { ApiOrg } from 'api/types/ApiOrg';
import { ApiUnpublishedOrg } from 'api/types/ApiUnpublishedOrg';
import { setError } from 'modules/main/store/ducks/error';

export type MainStoreOrgsState = {
  byId: Record<
    string,
    {
      org?: ApiOrg | ApiUnpublishedOrg;
      isFetching?: boolean;
      isUnpublished?: boolean;
    }
  >;
};

// Thunks

export const fetchOrg = createAsyncThunk<ApiOrg | ApiUnpublishedOrg, string>(
  'orgs/fetchOrg',
  // @ts-expect-error TS(2345): Argument of type '(orgId: string, thunkAPI: GetThu... Remove this comment to see the full error message
  async (orgId: string, thunkAPI) => {
    try {
      return await apiFetchOrg(orgId);
    } catch (e) {
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      if (e.statusCode !== 404) {
        // @ts-expect-error TS(2345): Argument of type 'unknown' is not assignable to pa... Remove this comment to see the full error message
        thunkAPI.dispatch(setError(e));
      } else {
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        thunkAPI.dispatch(setOrgUnpublished(orgId));
      }
    }
  },
);

// Slice

const orgsSlice = createSlice({
  name: 'orgs',
  initialState: {
    byId: {} as MainStoreOrgsState['byId'],
  },
  reducers: {
    setOrgUnpublished: (state: MainStoreOrgsState, action) => {
      state.byId[action.payload].isFetching = false;
      state.byId[action.payload].isUnpublished = true;
    },
    updateOrg: (state, action) => {
      state.byId[action.payload.id].org = action.payload;
    },
    partialUpdateOrg: (state, action) => {
      state.byId[action.payload.id] ||= {};
      state.byId[action.payload.id].org = {
        ...state.byId[action.payload.id].org,
        ...action.payload,
      };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchOrg.pending, (state: MainStoreOrgsState, action) => {
        state.byId[action.meta.arg] = {
          isFetching: true,
        };
      })
      .addCase(fetchOrg.fulfilled, (state, action) => {
        const orgId = action.meta.arg as string;
        state.byId[orgId].isFetching = false;

        if (action.payload) {
          state.byId[orgId].org = action.payload;
        }
      });
  },
});

export const orgsReducer = orgsSlice.reducer;

const {
  actions: { setOrgUnpublished, partialUpdateOrg },
} = orgsSlice;

export { partialUpdateOrg };
